import createReducer from '../../common/util/createReducer';
import {ActionTypes} from '../actions';

const INITIAL_STATE = {
  'loading': false,
  'dealerInfo': {},
  'orders': [],
  'invoicing': false,
  'agencies': [],
};

export const qualityControlInvoicing = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_QUALITY_CONTROL_INVOICING]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_QUALITY_CONTROL_INVOICING]: (state, action) => ({
      ...state,
      'loading': false,
      'dealerInfo': action.response.dealerInfo,
      'orders': action.response.data,
    }),
    [ActionTypes.FETCHED_QUALITY_CONTROL_INVOICING_FAILED]: (
      state,
      action
    ) => ({
      ...state,
      ...INITIAL_STATE,
    }),
    [ActionTypes.CREATING_QUALITY_CONTROL_INVOICE]: (state, action) => ({
      ...state,
      'invoicing': true,
    }),
    [ActionTypes.CREATED_QUALITY_CONTROL_INVOICE]: (state, action) => ({
      ...state,
      'invoicing': false,
    }),
    [ActionTypes.CREATED_QUALITY_CONTROL_INVOICE_FAILED]: (state, action) => ({
      ...state,
      'invoicing': false,
    }),
  })(state, action);
};
